import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  CampaignCapabilityConfigResponseDataSchema,
  UpsertCampaignCapabilityConfigBodySchema,
} from "schema"
import z from "zod"
import { campaignCapabilitiesQuery } from "../lib/campaignCapabilitiesQuery"

type Response = {
  data: z.infer<typeof CampaignCapabilityConfigResponseDataSchema>
}

type Props = z.input<typeof UpsertCampaignCapabilityConfigBodySchema> & {
  capabilityId: string
}

export function useUpsertCampaignCapabilityOverrideMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ capabilityId, campaignId, configOverride }: Props) => {
      const response = await axios.put<Response>(
        `/capabilities/${capabilityId}/campaign-override`,
        { campaignId, configOverride },
      )

      return response.data.data
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: campaignCapabilitiesQuery({ campaignId: variables.campaignId }).queryKey,
      })
    },
  })
}
